"use strict";

var _taggedTemplateLiteral = require("/home/circleci/poc-carditas-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    object-fit: cover;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardMedia = exports.cardMediaBase = void 0;

var _stylitas = require("@creditas/stylitas");

var cardMediaBase = function cardMediaBase() {
  return (0, _stylitas.css)(_templateObject());
};

exports.cardMediaBase = cardMediaBase;

var cardMedia = function cardMedia(_ref) {
  var isMedia = _ref.isMedia;
  return isMedia && (0, _stylitas.css)(_templateObject2());
};

exports.cardMedia = cardMedia;